import type { NavigationToggleType } from '@/storyblok/wirfuersklima/header/Header';
import { linkToString } from '@/storyblok/wirfuersklima/helper/urls';
import type { PartialMenuItemStoryblok } from '@/storyblok/wirfuersklima/types';
import classNames from 'classnames';

import classes from './Navigation.module.scss';

export type NavigationType = NavigationToggleType & {
  navigation: PartialMenuItemStoryblok[];
  id: string;
};

export default function NavigationToggle(props: NavigationType) {
  return (
    <nav
      id={props.id}
      className={classNames(classes['navigation'], props.isActive && classes['navigation--open'])}
      aria-hidden={!props.isActive}
    >
      <ul className={classes['navigation__list']}>
        {props.navigation.map((link: PartialMenuItemStoryblok) => (
          <li key={link._uid} className={classes['navigation__item']}>
            <a
              className={classes['navigation__link']}
              href={link.link ? linkToString(link.link) : '#'}
              onClick={props.toggleNavigation}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
